module.exports = __webpack_public_path__ + "static/img/effect-bg.19029ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/effect-bg.png
// module id = RwIp
// module chunks = 0